import styled from 'styled-components';

import { Box } from 'components/library';

export const Container = styled(Box)`
    width: 100%;
    max-width: 400px;
    margin: 0 auto;

    ${({ $paddingTop }) => $paddingTop && `padding-top: ${$paddingTop}px;`};
    ${({ $paddingBottom }) => $paddingBottom && `padding-bottom: ${$paddingBottom}px;`};
    ${({ $paddingX }) => $paddingX && `padding: ${$paddingX}px;`};
`;
